import React from 'react'
import styled from 'styled-components'
import {Link, Portal} from '@miro-site/core'

import Popup from './../../popup/Popup'

import {Transition} from 'react-transition-group'

import type {CategoryGroup, CategoryGroupItem, CategoryNavProps} from '../CategoryNav'

import Accordion from './../../accordion/Accordion'
import Item from './../../accordion/Item'

import useFullscreenModal from '../../../hooks/useFullscreenModal'

const transitionStyles = {
  entering: {opacity: 1, visibility: 'visible'},
  entered: {opacity: 1, visibility: 'visible'},
  exiting: {opacity: 0, visibility: 'hidden'},
  exited: {opacity: 0, visibility: 'hidden'},
}

const CategoryNavMobile = React.forwardRef<HTMLElement, CategoryNavProps>(
  ({rootGroups, isVisible = false, onMobilePopupClose, onCategoryOpen}, ref) => {
    useFullscreenModal(isVisible)

    return (
      <Transition in={isVisible} timeout={2500}>
        {state => (
          <Portal>
            <Popup
              $styles={{
                position: 'fixed',
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
                height: '100%',
                overflow: 'auto',
                zIndex: 710,
                textAlign: 'center',
                transition: `opacity 250ms ease-in-out, visibility 250ms ease-in-out`,
                visibility: 'hidden',
                opacity: 0,
                ...transitionStyles[state],
              }}
              onCloseClick={() => {
                if (onMobilePopupClose) {
                  onMobilePopupClose()
                }
              }}
            >
              <Accordion>
                {rootGroups.map((group: CategoryGroup, index) => {
                  return (
                    <Item key={index} header={group.title}>
                      {group.categories.map((category: CategoryGroupItem) => (
                        <CategoryLink
                          onClick={e => {
                            if (onCategoryOpen) {
                              e.preventDefault()
                              onCategoryOpen(category)
                            }
                          }}
                          key={category.title}
                          href={category.href}
                        >
                          {category.title}
                        </CategoryLink>
                      ))}
                    </Item>
                  )
                })}
              </Accordion>
            </Popup>
          </Portal>
        )}
      </Transition>
    )
  },
)

CategoryNavMobile.displayName = 'CategoryNavMobile'

const CategoryLink = styled(Link).attrs({
  $size: 'default',
  $styles: {
    marginLeft: [20, null, null, null],
    paddingBottom: [30, null, null, null],
  },
})`
  display: block;
  text-align: left;
  font-weight: 400;
  color: ${props => props.theme.templates.colors.secondary60};

  border-bottom: none;
`

export default CategoryNavMobile
